// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(function(i){return i[1]});
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".block-reassurance{align-items:center;display:flex;flex-direction:column;gap:var(--spacing);padding:calc(var(--spacing)*5.6) calc(var(--spacing)*2)}@media (min-width:48.0625em){.block-reassurance{gap:calc(var(--spacing)*2)}}.block-reassurance img{height:7.5rem;width:7.5rem}.block-reassurance .block-text{max-width:30rem}", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
module.exports = ___CSS_LOADER_EXPORT___;
